import React, { Component, lazy } from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

const IoIosArrowForward = lazy(() => import(`react-icons/io/index`).then(module=>({ default:module.IoIosArrowForward })))
const IoIosArrowBack = lazy(() => import(`react-icons/io/index`).then(module=>({ default:module.IoIosArrowBack })))

import carousel1 from './../images/carousel-1.webp';
import carousel2 from './../images/carousel-2.webp';
import carousel3 from './../images/carousel-3.webp';
import carousel4 from './../images/carousel-4.webp';
import carousel5 from './../images/carousel-5.webp';
import carousel6 from './../images/carousel-6.webp';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <CarouselProvider naturalSlideWidth={100} naturalSlideHeight={220} totalSlides={6}>
        <Slider>
          <Slide index={0}><h2>cronograma personalizado!</h2><img src={carousel1} alt="Celular com aplicativo da Lampejo mostrando a visão semanal do cronograma" title="Lampejo: Cronograma Semanal" /></Slide>
          <Slide index={1}><h2>saiba o que estudar todos os dias</h2><img src={carousel2} alt="Celular com aplicativo da Lampejo mostrando a visão diária do cronograma" title="Lampejo: Cronograma Diário" /></Slide>
          <Slide index={2}><h2>acompanhe o<br/>seu dia-a-dia</h2><img src={carousel3} alt="Celular com aplicativo da Lampejo mostrando a visão mensal do cronograma" title="Lampejo: Cronograma Mensal" /></Slide>
          <Slide index={3}><h2>questões focadas<br/>no ENEM</h2><img src={carousel4} alt="Celular com aplicativo da Lampejo apresentando uma questão de cartografia" title="Lampejo: Questão de Cartografia" /></Slide>
          <Slide index={4}><h2>resoluções para te ajudar no aprendizado</h2><img src={carousel5} alt="Celular com aplicativo da Lampejo apresentando uma resolução de exercício" title="Lampejo: Resolução de Exercício" /></Slide>
          <Slide index={5}><h2>aprenda se<br/>divertindo!</h2><img src={carousel6} alt="Celular com aplicativo da Lampejo mostrando um jogo de corrida usado em uma aula de física" title="Lampejo: Corrida e Aceleração" /></Slide>
        </Slider>
        <ButtonBack className={'buttonBack'}><IoIosArrowBack/></ButtonBack>
        <ButtonNext className={'buttonNext'}><IoIosArrowForward/></ButtonNext>
      </CarouselProvider>
    )
  }

}